import { PickerSymbolType } from "src/app/shared/picker/models/picker-symbol-type.enum";
import { PickerSymbol } from "src/app/shared/picker/models/picker-symbol.model";

export const NUMPAD: PickerSymbol[][] = [
    [
        { value: "1", type: PickerSymbolType.Digit },
        { value: "2", type: PickerSymbolType.Digit },
        { value: "3", type: PickerSymbolType.Digit },
    ],
    [
        { value: "4", type: PickerSymbolType.Digit },
        { value: "5", type: PickerSymbolType.Digit },
        { value: "6", type: PickerSymbolType.Digit },
    ],
    [
        { value: "7", type: PickerSymbolType.Digit },
        { value: "8", type: PickerSymbolType.Digit },
        { value: "9", type: PickerSymbolType.Digit },
    ],
    [
        { value: "0", type: PickerSymbolType.Digit },
        { value: "remove", type: PickerSymbolType.Clear },
    ],
];
